import React from 'react';
import { Icon } from 'bench-internal-theme';
import { colors } from 'bench-style-constants';
import { HeaderCell, HeaderIconCell } from './DataEntryTableHeaderCells.styles';
import { DataEntryTableSelectAllButton } from './data-entry-table/components/DataEntryTableSelectAllButton';
import { DataEntry, LedgerAccount } from '../types';
import Tooltip from 'primitive-components/Tooltip';
import { SortDirection } from '@tanstack/react-table';

const HEADER_ICON_CELL_CONFIG = new Map();
HEADER_ICON_CELL_CONFIG.set('hasComments', {
  title: 'Has client comments, client categorization response, or internal notes',
  icon: 'speechBubble',
});
HEADER_ICON_CELL_CONFIG.set('isLedgerSelectedByClient', {
  title: 'Client selected this ledger account',
  icon: 'circleCheck',
});
HEADER_ICON_CELL_CONFIG.set('hasAttachment', { title: 'Has attachment', icon: 'paperclip' });
HEADER_ICON_CELL_CONFIG.set('hasFlaggedInternalNote', {
  title: 'Has flagged internal note(s)',
  icon: 'flagFilled',
});

export const getHeaderElement = (
  header: string,
  dataEntries: DataEntry[],
  totalEntries: number,
  ledgerId: LedgerAccount['id'],
  sortable: boolean,
  sorted: false | SortDirection,
): JSX.Element | null => {
  switch (header) {
    case 'isSelectedOrHasQualityIssues':
      return (
        <HeaderIconCell aria-label={'select all'}>
          {dataEntries.length > 0 && (
            <DataEntryTableSelectAllButton
              ledgerId={ledgerId}
              totalEntries={totalEntries}
              controlledDataEntries={dataEntries}
            />
          )}
        </HeaderIconCell>
      );
    case 'hasComments':
    case 'isLedgerSelectedByClient':
    case 'hasAttachment':
    case 'hasFlaggedInternalNote': {
      const config = HEADER_ICON_CELL_CONFIG.get(header);
      return (
        <Tooltip contentComponent={config.title}>
          <HeaderIconCell key={header} aria-label={header}>
            <Icon color={colors.clay} icon={config.icon} size="small" />
          </HeaderIconCell>
        </Tooltip>
      );
    }
    default:
      return (
        <HeaderCell
          align={header === 'Debit' || header === 'Credit' ? 'right' : 'left'}
          interactive={sortable}
        >
          {header}
          <div>
            {sortable
              ? {
                  asc: (
                    <Icon color={colors.stone} icon="sortDesc" size="medium" viewBox="0 0 16 16" />
                  ),
                  desc: (
                    <Icon color={colors.stone} icon="sortAsc" size="medium" viewBox="0 0 16 16" />
                  ),
                  false: (
                    <Icon color={colors.stone} icon="sortable" size="medium" viewBox="0 0 16 16" />
                  ),
                }[sorted as string] ?? null
              : null}
          </div>
        </HeaderCell>
      );
  }
};
